// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// `.env.ts` is generated by the `npm run env` command
import {env} from './.env';

export const environment = {
    demoMode: true,
    production: true,
    version: env.npm_package_version + '-prod',
    serverUrl: 'https://admin.trustee.yoolo.lv/api',
    triggersApiUrl: 'https://admin.trustee.yoolo.lv/api/admin/notification-triggers',
    defaultLanguage: 'en-US',
    credentialsKey: 'credentials',
    sumSubUrl: 'https://test-api' + '.sumsub.com/checkus#/applicant/',
    supportedLanguages: [
        'en-US',
        'fr-FR'
    ],
    etherscanApiKey: 'FU8YCAEDMCSG7UW1U1FWRP1SP8GYVDBKZH'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.


// `.env.ts` is generated by the `npm run env` command
// import env from './.env';
//
// export const environment = {
//     demoMode: true,
//     production: true,
//     version: env.npm_package_version + '-prod',
//     serverUrl: 'https://admin.trustee.yoolo.lv/api',
//     triggersApiUrl: 'https://admin.trustee.yoolo.lv/api/admin/notification-triggers',
//     defaultLanguage: 'en-US',
//     credentialsKey: 'credentials',
//     sumSubUrl: 'https://test-api' + '.sumsub.com/checkus#/applicant/',
//     supportedLanguages: [
//         'en-US',
//         'fr-FR'
//     ],
//     etherscanApiKey: 'FU8YCAEDMCSG7UW1U1FWRP1SP8GYVDBKZH'
// };
